import React, { useState, useEffect, useRef } from 'react';
import Colors from '../utilities/Colors';
import { useGlobalHoveredId, useGlobalSelectedId, useGlobalActiveGeography, useGlobalActiveIndicator, onSetActiveModuleId } from '../../data/StatusStore';
import { d2gRound } from '../utilities/Utilities';
import { siteConfig } from '../../config/siteConfig';

interface BarChartMetaProps {
  dataArray: DataItem[];
  indicator: any;
  data: any;
  options: any;
  mostChangeActive: boolean;
  setMostChangeActive: (active: boolean) => void;
  leastChangeActive: boolean;
  setLeastChangeActive: (active: boolean) => void;
  yearRange: any[];
  setYearRange: (range: any[]) => void;
  change: number | null;
  setChange: (change: number) => void;
  year: string| null;
  setSelectedIndicator:Function;
  onSetActiveIndicator:Function;
}

interface DataItem {
  id: string;
  value: number;
  x?: number;
  y?: number;
}

const COTMeta: React.FC<BarChartMetaProps> = ({
  dataArray,
  indicator,
  data,
  options,
  mostChangeActive,
  setMostChangeActive,
  leastChangeActive,
  setLeastChangeActive,
  yearRange,
  setYearRange,
  change,
  setChange,
  year,
  setSelectedIndicator,
  onSetActiveIndicator
}) => {

  const hoveredId = useGlobalHoveredId();
  const activeGrography = useGlobalActiveGeography();
  const selectedId = useGlobalSelectedId() as any;
  const activeIndicator = useGlobalActiveIndicator();
  console.log("A040825 data", data);
  console.log("A040825 indicator", indicator);
  console.log("A040825 dataArray", dataArray);
  console.log("A040825 options", options);

  // NEW: track which button is hovered
  const [hoveredButton, setHoveredButton] = useState<string | null>(null);

  useEffect(() => {
    console.log("A040825 options", options);
    if (options && options.variables && options.variables.length > 0) {
      const yearVariables = options.variables
        .filter((variable: any) => variable.sort && variable.sort.YEAR);
      console.log("C042925 yearVariables", yearVariables);
      if (yearVariables.length > 0) {
        const minYearVariable = yearVariables.reduce((minVar: any, currentVar: any) => {
          const currentYear = parseInt(currentVar.sort.VARIABLE_NAME.slice(-4), 10);
          const minYear = parseInt(minVar.sort.VARIABLE_NAME.slice(-4), 10);
          return currentYear < minYear ? currentVar : minVar;
        });
        const maxYearVariable = yearVariables.reduce((maxVar: any, currentVar: any) => {
          const currentYear = parseInt(currentVar.sort.VARIABLE_NAME.slice(-4), 10);
          const maxYear = parseInt(maxVar.sort.VARIABLE_NAME.slice(-4), 10);
          return currentYear > maxYear ? currentVar : maxVar;
        });
        console.log("AA040825 minYearVariable", minYearVariable);
        console.log("AA040825 maxYearVariable", maxYearVariable);  
        setYearRange([minYearVariable, maxYearVariable]);
      }
    }
  }, [options]);

  useEffect(() => {
    if (yearRange[0] && yearRange[1] && selectedId) {
        console.log("B040825 yearRange", yearRange);
        console.log("B040825 data", data);
        let firstYear = data.keyIndexDataArray[yearRange[0].variable][selectedId].value;
        let lastYear = data.keyIndexDataArray[yearRange[1].variable][selectedId].value;
        let _change = ((lastYear - firstYear) / firstYear) * 100;
        setChange(_change);
    }

  }, [yearRange, selectedId]);

  return (
    <>
      <div className="module-child-1-meta">
        {/*<div className="module-child-1-meta-label">
          {indicator.label}
        </div> */}    
        <div className="module-child-1-meta-label">
          Percent Change
        </div>      
        <div className="module-child-1-meta-label">
          {/*`${yearRange[0] ? yearRange[0].sort.YEAR : null}—${yearRange[1] ? yearRange[1].sort.YEAR : null}`*/}
          {`${yearRange[0] ? yearRange[0].sort.VARIABLE_NAME.slice(-4) : null}—${yearRange[1] ? yearRange[1].sort.VARIABLE_NAME.slice(-4) : null}`}
        </div>      
      </div>      
      <div className="module-child-1-meta">      
        <div className='module-meta-stat-label'>       
          <div className="module-meta-stat">
            {/*selectedId && indicator && indicator.variable ? d2gRound(data.dataJSON[selectedId][indicator.variable], { DESCRIPTOR: data.meta["DESCRIPTOR"][indicator.variable] }) : "NA"*/}
            <span style={{ fontSize:'14pt', fontWeight:'normal'}}>
              {`${change 
                ? change > 0 
                  ? "+" 
                  : change === 0
                    ? ""
                    : "-" 
                : ""}`}
            </span> {`${change 
              ? d2gRound(Math.abs(change), { DESCRIPTOR: "X.#"}) 
              : 
                change === 0 
                ? d2gRound(Math.abs(change), { DESCRIPTOR: "X.#"})
                : "NA"} %`}
          </div>
          {/*<div className="module-meta-label">
            {indicator.label}
          </div>*/}
        </div>          
      </div>        
      <div className="module-child-2-meta-label">
          Show Only
      </div>
      
      {/* Wrap each button in a relatively positioned container to position the tooltip above */}
      <div style={{ position: 'relative', display: 'inline-block', marginRight: '10px' }}>
        <div 
          className={`module-child-change-button ${mostChangeActive ? "button-active" : ""}`} 
          onClick={() => { 
            setMostChangeActive(!mostChangeActive); 
            setLeastChangeActive(false); 
            let noneed = false;
            options.variables.forEach((v: any) => {
              console.log("C122825 v", v );
              if (v.variable === activeIndicator){
                noneed = true;
              }
            });
            console.log("C122825 noneed", noneed );
            if (!noneed){
              console.log("C122825 options.variables[0].variable", options.variables[0].variable );
              onSetActiveIndicator(options.variables[0].variable, options.type.toLowerCase(), options.variables[0].sort.moduleId);
              setSelectedIndicator(options.variables[0].variable);
              onSetActiveModuleId(options.variables[0].sort.moduleId);
            }
          }}
          onMouseEnter={() => setHoveredButton("most")}
          onMouseLeave={() => setHoveredButton(null)}
        >
          largest change
        </div>
        {hoveredButton === "most" && (
          <div
            style={{
              position: 'absolute',
              bottom: '80%', // position above the button
              left: '50%',
              transform: 'translateX(-50%)',
              marginBottom: '5px',
              backgroundColor: '#fff',
              border: '2px solid #ccc',
              borderRadius: '6px',
              padding: '6px',
              pointerEvents: 'none',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              zIndex: 10,
              color: '#333',
              width: '125px',
              textAlign: 'center',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              lineHeight: '1.25'
            }}
          >
            <div style={{ fontSize: '10px', color: '#666', marginTop: '0px' }}>
              Show the 10 places with the <b>largest change</b> in value between <b>{yearRange[0].sort.VARIABLE_NAME.slice(-4)}</b> and <b>{yearRange[1].sort.VARIABLE_NAME.slice(-4)}</b>.
            </div>
            {/* Callout notch */}
            <div
              style={{
                position: 'absolute',
                bottom: '-7px',
                left: '50%',
                transform: 'translateX(-50%) rotate(-45deg)',
                width: '12px',
                height: '12px',
                backgroundColor: '#fff',
                borderLeft: '2px solid #ccc',
                borderBottom: '2px solid #ccc',
                boxShadow: '-1px 1px 2px rgba(0, 0, 0, 0.1)',
              }}
            />
          </div>
        )}
      </div>

      <div style={{ position: 'relative', display: 'inline-block', marginRight: '10px' }}>
        <div 
          className={`module-child-change-button ${leastChangeActive ? "button-active" : ""}`} 
          onClick={() => { 
            setLeastChangeActive(!leastChangeActive); 
            setMostChangeActive(false); 
            let noneed = false;
            options.variables.forEach((v: any) => {
              console.log("C122825 v", v );
              if (v.variable === activeIndicator){
                noneed = true;
              }
            });
            console.log("C122825 noneed", noneed );
            if (!noneed){
              console.log("C122825 options.variables[0].variable", options.variables[0].variable );
              onSetActiveIndicator(options.variables[0].variable, options.type.toLowerCase(), options.variables[0].sort.moduleId);
              setSelectedIndicator(options.variables[0].variable);
              onSetActiveModuleId(options.variables[0].sort.moduleId);
            }
          }}
          onMouseEnter={() => setHoveredButton("least")}
          onMouseLeave={() => setHoveredButton(null)}
        >
          smallest change
        </div>
        {hoveredButton === "least" && (
          <div
            style={{
              position: 'absolute',
              bottom: '80%',
              left: '50%',
              transform: 'translateX(-50%)',
              marginBottom: '5px',
              backgroundColor: '#fff',
              border: '2px solid #ccc',
              borderRadius: '6px',
              padding: '6px',
              pointerEvents: 'none',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              zIndex: 10,
              color: '#333',
              width: '125px',
              textAlign: 'center',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              lineHeight: '1.25'
            }}
          >
            <div style={{ fontSize: '10px', color: '#666', marginTop: '0px' }}>
              Show the 10 places with the <b>smallest change</b> in value between <b>{yearRange[0].sort.VARIABLE_NAME.slice(-4)}</b> and <b>{yearRange[1].sort.VARIABLE_NAME.slice(-4)}</b>.
            </div>
            {/* Callout notch */}
            <div
              style={{
                position: 'absolute',
                bottom: '-7px',
                left: '50%',
                transform: 'translateX(-50%) rotate(-45deg)',
                width: '12px',
                height: '12px',
                backgroundColor: '#fff',
                borderLeft: '2px solid #ccc',
                borderBottom: '2px solid #ccc',
                boxShadow: '-1px 1px 2px rgba(0, 0, 0, 0.1)',
              }}
            />
          </div>
        )}
      </div>
      <div
        style={{
          marginTop:"15px",
        }}>
        by <b>{siteConfig.geographies['CD']?.label ?? 'Community District'}</b>{year ? <span> and <b>{year}</b></span> : ""}</div>
      {/*<div
          style={{
            marginRight:"15px",
          }}
        >
        {`${data.meta["NOTES"][indicator.variable]}`}
        <br/><div style={{ color: '#9E9C9C', paddingTop:'5px'}}>Source: <a className="source-link" href={`${data.meta["SOURCE URL"][indicator.variable]}`} target='_blank'>{`${data.meta["SOURCE NAME"][indicator.variable]}`}</a></div> 
      </div>*/}
    </>
  );
};

export default COTMeta;
